const merge = require('deepmerge')

const defaultConfig = {
  api_root_url: '/api/',
  system_name: '青柠檬宿综合管理系统',
  website_title: ' - 青柠檬宿综合管理系统',
  branch_name: '车立方店',
  startup_date: '2017-05-01T00:00:00.000+0000',
  branches: [],
  logic: {
    room_editable: true,
    lezhu_meter: false,
    manual_meter: false,
  },
  forms: {
    rent: {
      date_end_editable: true,
    },
  },
  warning_color_levels: [25, 15, 10, 5, 0],
  native_ext: {

  },
}

let override = {}

try {
  override = require('./config.override.js') || {}
} catch (error) {}

const config = merge(defaultConfig, override)

export default config



// WEBPACK FOOTER //
// ./config.js